import { RootState } from '../../../../store/store';
import { useSelector } from 'react-redux';
import { gql, useMutation } from '@apollo/client';
import { AddCorsDomainInput, Cors } from '../../../../types/schema/cors.types';

const GQL_MUT = gql`
  mutation AddCorsDomain($input: AddCorsDomainInput!) {
    addCorsDomain(input: $input) {
      _id
    }
  }
`;

// Define the types for the mutation response and input
interface AddCorsDomainMutationData {
  addCorsDomain: Cors;
}

interface AddCorsDomainInputType {
  input: AddCorsDomainInput;
}

export const useAddCorsDomain = () => {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const [addCorsDomainGql, { data, error, loading }] = useMutation<
    AddCorsDomainMutationData,
    AddCorsDomainInputType
  >(GQL_MUT);

  const addCorsDomain = async (input: AddCorsDomainInput) => {
    const { data, errors } = await addCorsDomainGql({
      variables: {
        input: input,
      },
      context: {
        headers: {
          cookie: `jwt=${jwt}`,
          authorization: jwt ? `Bearer ${jwt}` : '',
        },
      },
    });

    return {
      addCorsDomain: data?.addCorsDomain,
      error: errors ? errors[0].message : null,
    };
  };

  return { addCorsDomain, data, error, loading };
};
